exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".report-review {\n  min-width: 768px; }\n  .report-review span {\n    display: block;\n    vertical-align: middle; }\n  .report-review .left {\n    width: 250px;\n    float: left; }\n  .report-review .right {\n    font-weight: bold;\n    overflow: hidden;\n    margin-left: 250px; }\n  .report-review .submit {\n    cursor: pointer;\n    float: right;\n    margin-top: 20px;\n    margin-bottom: 25px;\n    margin-left: 10px;\n    user-select: none;\n    width: 150px; }\n  .report-review .back {\n    cursor: pointer;\n    float: right;\n    margin-top: 20px;\n    margin-bottom: 25px;\n    user-select: none;\n    width: 150px; }\n  .report-review .anticon {\n    padding-left: 7px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./client/modules/ReportForm/components/ReportReview/style.scss
// module id = 1009
// module chunks = 0